import Enums from '../types/api/Enums';

/**
 * Available currency codes and their display labels.
 * These must match the currency_code enum in the database.
 */
export const CURRENCY_OPTIONS = [
  { value: Enums.CurrencyCode.USD, label: 'USD - United States Dollar' },
  { value: Enums.CurrencyCode.AUD, label: 'AUD - Australian Dollar' },
  { value: Enums.CurrencyCode.CAD, label: 'CAD - Canadian Dollar' },
  { value: Enums.CurrencyCode.GBP, label: 'GBP - British Pound Sterling' },
];

export type CurrencyCode = Enums.CurrencyCode;

// Every currency above is shown in cents.
export const CURRENCY_MIN_FRACTION_DIGITS = 2;
